import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import TopBar from '../../../Components/TopBar';

export default function AffiliateCalculator() {
  const [perDay, setPerDay] = useState(15);
  const [productRate, setProductRate] = useState(50); // Product Rate In USD or CAD, default USD
  const [earnings, setEarnings] = useState(perDay * productRate * 0.15 * 30); // perDay * 50 dollar bundle * 15% commission * 30 days
  const [currency, setCurrency] = useState('USD'); // switches between USD or CAD, default USD
  const [showTable, setShowTable] = useState(false);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    if (perDay) {
      setEarnings(Math.round(perDay * productRate * 0.15 * 30));
      return;
    }
    setPerDay(0);
    setEarnings(Math.round(0 * productRate * 0.15 * 30));
  }, [perDay, productRate]);

  // tracks the changes in button
  useEffect(() => {
    if (currency === 'USD') {
      setProductRate(50);
    } else if (currency === 'CAD') {
      setProductRate(66);
    }
  }, [setProductRate, currency]);

  return (
    <>
      <TopBar affiliatePage />
      <div className="w-full min-h-screen bg-altBack font-brand">
        <div className="flex items-center justify-center mx-6">
          <div className="pt-32 text-center">
            <h1 className="mb-4 text-4xl font-bold leading-10 text-center text-brandcolor font-brand lg:text-5xl">
              Stamped Partner Earnings Calculator
            </h1>{' '}
            <p className="w-full m-auto text-center text-gray-700 text-md lg:w-1/2 lg:text-lg font-brand">
              Calculate how much you can make per month as a part of Stamped's Partner Program. Become an affiliate to supplement your income, and
              more importantly to help prevent fraud by offering students a real solution.{' '}
              <span className="underline"> Learn about Stamped's mission </span>
            </p>
            <div className="flex flex-col items-center justify-center mt-20">
              <label className="text-2xl font-bold text-gray-900"> Estimated sales per day </label>
              <div className="flex">
                <div className="flex items-center p-2 mt-1 mb-1 ml-1 text-xs font-semibold text-white bg-red-600 shadow-md rounded-tl-md rounded-bl-md">
                  {' '}
                  Units{' '}
                </div>
                <input
                  onChange={(event) => {
                    setPerDay(parseInt(event.target.value));
                  }}
                  value={perDay}
                  type="number"
                  placeholder="20000"
                  className="p-2 pl-5 mt-1 mb-1 mr-1 transition-all duration-500 bg-white shadow-md cursor-pointer rounded-tr-md rounded-br-md hover:shadow-xl"
                />
              </div>
              <p className="w-2/3 my-2 text-xs text-gray-600 lg:w-1/6 "> On an average, our Affiliate Partners sell 15 Stamped Products a day. </p>
            </div>
            <div className="py-6">
              <h1 className="text-6xl font-bold lg:text-10xl text-brandcolor"> $ {earnings} </h1>
              <span> {currency} </span>
              <p className="my-10 -mt-2"> per month estimated earnings </p>
              <div className="flex items-center justify-center">
                <button
                  onClick={() => setCurrency('USD')}
                  className={`px-6 py-2 my-4 text-xs font-bold ${
                    currency === 'USD' ? ' text-white bg-brandcolor' : 'bg-white text-gray-900'
                  } rounded-md rounded-r-none shadow-sm  focus:outline-none`}
                >
                  {' '}
                  USD{' '}
                </button>
                <button
                  onClick={() => setCurrency('CAD')}
                  className={`px-6 py-2 my-4 text-xs font-bold ${
                    currency === 'CAD' ? ' text-white bg-brandcolor' : 'bg-white text-gray-900'
                  } rounded-md rounded-l-none shadow-sm  focus:outline-none`}
                >
                  CAD
                </button>
              </div>
              <section>
                <div className="max-w-lg p-6 m-auto my-6 text-gray-700 bg-darkAlt">
                  <span className="text-xs font-semibold text-left text-gray-600 uppercase">Calculation</span>
                  <br />
                  Stamped's partners start their affiliate income at ~ 15% per Stamped Product. Selling an average of {perDay} 
                  {perDay === 1 ? 'product' : 'products'} per day at 15% commission will result in <b> {currency + ' ' + earnings} / month.</b>
                </div>
              </section>
              <section>
                <button
                  onClick={() => setShowTable(!showTable)}
                  className="px-4 py-2 mb-6 -mt-2 text-xs text-gray-600 border-none cursor-pointer focus:outline-none"
                >
                  {showTable ? 'Hide' : 'Show'} Earnings Table
                </button>
                {showTable && (
                  <table className="max-w-lg m-auto my-6 text-xs border-2 border-black">
                    <tr className="border border-black">
                      <td className="px-3 border-2 border-black"> Items Per Day </td>
                      <td className="px-3 border-2 border-black"> Product Value </td>
                      <td className="px-3 border-2 border-black"> Commission (%) </td>
                      <td className="px-3 border-2 border-black"> Commission Per Day </td>
                      <td className="px-3 border-2 border-black"> Commission Per Month </td>
                    </tr>
                    <tr>
                      <td className="border-2 border-black">
                        {currency} {productRate}
                      </td>
                      <td className="border-2 border-black"> {perDay} </td>
                      <td className="border-2 border-black"> 15% </td>
                      <td className="border-2 border-black">
                        {currency} {productRate * perDay * 0.15}{' '}
                      </td>
                      <td className="font-bold text-black border-2 border-black">
                        {currency} {productRate * perDay * 0.15 * 30}{' '}
                      </td>
                    </tr>
                  </table>
                )}
              </section>
              <Link to="/affiliate/apply">
                <button className="max-w-lg pt-2 pb-2 pl-5 pr-5 m-auto text-sm font-bold text-center text-white rounded-md shadow cursor-pointer lg:w-1/3 bg-brandcolor font-brand">
                  Apply To Become An Affiliate
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
